/*
 * Copyright (c) 2019 Cédric Bodet.
 * The MIT License
 * http://www.opensource.org/licenses/mit-license
 */
import 'worldwindjs' //WorldWind global
import React from 'react'

/* global WorldWind */

const BASE_PATH = "https://tampere.zerogravity.fi/data/d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1/";

const FILENAMES = [
    "d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_0-0.tif",
    "d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_0-1536.tif",
    "d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_0-2304.tif",
    "d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_0-3072.tif",
    "d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_0-3840.tif",
    "d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_0-4608.tif",
    "d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_0-768.tif",
    //"d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_10752-0.tif",
    //"d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_10752-1536.tif",
    //"d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_10752-2304.tif",
    //"d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_10752-3072.tif",
    //"d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_10752-3840.tif",
    //"d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_10752-4608.tif",
    //"d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_10752-768.tif",
    "d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_1536-0.tif",
    "d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_1536-1536.tif",
    "d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_1536-2304.tif",
    "d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_1536-3072.tif",
    "d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_1536-3840.tif",
    "d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_1536-4608.tif",
    "d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_1536-768.tif",
    "d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_2304-0.tif",
    "d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_2304-1536.tif",
    "d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_2304-2304.tif",
    "d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_2304-3072.tif",
    "d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_2304-3840.tif",
    "d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_2304-4608.tif",
    "d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_2304-768.tif",
    "d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_3072-0.tif",
    "d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_3072-1536.tif",
    "d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_3072-2304.tif",
    "d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_3072-3072.tif",
    "d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_3072-3840.tif",
    "d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_3072-4608.tif",
    "d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_3072-768.tif",
    "d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_3840-0.tif",
    "d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_3840-1536.tif",
    "d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_3840-2304.tif",
    "d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_3840-3072.tif",
    "d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_3840-3840.tif",
    "d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_3840-4608.tif",
    "d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_3840-768.tif",
    "d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_4608-0.tif",
    "d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_4608-1536.tif",
    "d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_4608-2304.tif",
    "d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_4608-3072.tif",
    "d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_4608-3840.tif",
    "d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_4608-4608.tif",
    "d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_4608-768.tif",
    "d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_5376-0.tif",
    "d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_5376-1536.tif",
    "d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_5376-2304.tif",
    "d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_5376-3072.tif",
    "d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_5376-3840.tif",
    "d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_5376-4608.tif",
    "d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_5376-768.tif",
    "d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_6144-0.tif",
    "d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_6144-1536.tif",
    "d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_6144-2304.tif",
    "d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_6144-3072.tif",
    "d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_6144-3840.tif",
    "d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_6144-4608.tif",
    "d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_6144-768.tif",
    "d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_6912-0.tif",
    "d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_6912-1536.tif",
    "d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_6912-2304.tif",
    "d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_6912-3072.tif",
    "d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_6912-3840.tif",
    "d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_6912-4608.tif",
    "d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_6912-768.tif",
    "d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_768-0.tif",
    "d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_768-1536.tif",
    "d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_768-2304.tif",
    "d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_768-3072.tif",
    "d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_768-3840.tif",
    "d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_768-4608.tif",
    "d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_768-768.tif",
    "d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_7680-0.tif",
    "d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_7680-1536.tif",
    "d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_7680-2304.tif",
    "d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_7680-3072.tif",
    "d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_7680-3840.tif",
    "d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_7680-4608.tif",
    "d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_7680-768.tif",
    //"d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_8448-0.tif",
    //"d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_8448-1536.tif",
    //"d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_8448-2304.tif",
    //"d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_8448-3072.tif",
    //"d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_8448-3840.tif",
    //"d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_8448-4608.tif",
    //"d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_8448-768.tif",
    //"d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_9216-0.tif",
    //"d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_9216-1536.tif",
    //"d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_9216-2304.tif",
    //"d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_9216-3072.tif",
    //"d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_9216-3840.tif",
    //"d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_9216-4608.tif",
    //"d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_9216-768.tif",
    //"d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_9984-0.tif",
    //"d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_9984-1536.tif",
    //"d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_9984-2304.tif",
    //"d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_9984-3072.tif",
    //"d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_9984-3840.tif",
    //"d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_9984-4608.tif",
    //"d4fdb6a2-6fec-4efe-bcc1-6e8e007012c1_9984-768.tif",
];

export default class TampereGeoTiff extends WorldWind.RenderableLayer {
    constructor() {
        super("High-resolution image");

        this.doRender.bind(this);

        this.tilesAdded = false;
    }

    doRender(dc) {
        if (!this.tilesAdded) {
            this.tilesAdded = true;

            console.log("Loading high resolution imagery...");
            FILENAMES.forEach(filename => {
                const resourceUrl = BASE_PATH + filename;

                const renderTile = (geoTiffReader, xhrStatus) => {
                    if (!geoTiffReader) {
                        // Error, provide the status text to the console.
                        console.log(xhrStatus);
                        return;
                    }

                    // Display the obtained GeoTiff imagery with a WorldWind SurfaceImage renderable.
                    const surfaceGeoTiff = new WorldWind.SurfaceImage(
                        geoTiffReader.metadata.bbox,
                        new WorldWind.ImageSource(geoTiffReader.getImage())
                    );

                    // Add the SurfaceImage to the GeoTiff layer.
                    this.addRenderable(surfaceGeoTiff);

                    // Request a redraw once the image is loaded.
                    dc.redrawRequested = true;

                    console.log("Loaded " + filename);
                };

                // Load the GeoTiff using the Reader's built-in XHR retrieval function.
                WorldWind.GeoTiffReader.retrieveFromUrl(resourceUrl, renderTile);
            });
        }

        super.doRender(dc);
        if (this.inCurrentFrame) {
            dc.screenCreditController.addCredit(
                " UP42 by Airbus",
                WorldWind.Color.LIGHT_GRAY);
        }
    }

    getLayerDisplayInformation() {
        return (<div>
            <p>
                High resolution imagery provided by UP42 and Airbus Pléaides.
            </p>
        </div>);
    }
}
